import React from 'react';
import {
  DateRangeDropdownV2,
  DocumentNumberRangeFieldV2 as DocumentNumberRangeField,
  SearchFieldV2 as SearchField,
  FormFieldV2 as FormField
} from '@/components/custom/erp';
import { QUERY_KEYS, warehouseSearchColumns } from '@/constants';
import { useSearchFieldsState } from '../../hooks';
import { Label } from '@/components/ui/label';
import { KhoHang } from '@/types/schemas';
import { FormMode } from '@/types/form';

interface BasicInfoTabProps {
  searchFields: ReturnType<typeof useSearchFieldsState>;
}

export const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ searchFields }) => {
  return (
    <div className='space-y-1 p-4'>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Ngày c/từ (từ/đến)</Label>
        <DateRangeDropdownV2
          fromDateName='ngay_ct1'
          toDateName='ngay_ct2'
          toFieldClassName='w-44'
          fromFieldClassName='w-44'
        />
      </div>

      <div className='flex items-center'>
        <DocumentNumberRangeField
          fromName='so_ct1'
          toName='so_ct2'
          labelClassName='w-40 min-w-40'
          label='Số c/từ (từ/đến)'
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Loại xuất</Label>
        <FormField
          className='min-w-[200px]'
          type='select'
          name='ma_ngv'
          options={[
            { label: 'Tất cả', value: 'ALL' },
            { label: '1. Đ/c sổ sách', value: '1' },
            { label: '2. Đ/c thực tế', value: '2' },
            { label: '3. Cả hai', value: '3' }
          ]}
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Giao dịch</Label>
        <FormField
          className='min-w-[200px]'
          type='select'
          name='ma_gd'
          options={[
            { label: 'Tất cả', value: 'ALL' },
            { label: 'DC. Điều chỉnh', value: 'DC' },
            { label: 'XK. Xuất khác', value: 'XK' },
            { label: 'NB. Điều chuyển nội bộ', value: 'NB' }
          ]}
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Mã kho xuất</Label>
        <div className='w-full'>
          <SearchField<KhoHang>
            type='text'
            displayRelatedField='ten_kho'
            columnDisplay='ma_kho'
            searchEndpoint={`/${QUERY_KEYS.KHO_HANG}`}
            searchColumns={warehouseSearchColumns}
            dialogTitle='Danh mục kho hàng'
            value={searchFields.selectedWarehouse?.ma_kho}
            relatedFieldValue={searchFields.selectedWarehouse?.ten_kho}
            onRowSelection={searchFields.setSelectedWarehouse}
          />
        </div>
      </div>

      {/* Diễn giải - Description Field */}
      <div className='flex items-center'>
        <Label className='w-40 min-w-40 text-left text-sm font-normal'>Diễn giải</Label>
        <div className='flex-1'>
          <FormField className='w-full' type='text' name='dien_giai' />
        </div>
      </div>
    </div>
  );
};
